import GamecenterEditedContestModal from '../../../../common/components/GamecenterEditedContestModal/GamecenterEditedContestModal';
import GamecenterEntriesPageScheduled from '../../../../common/components/GamecenterEntriesPageScheduled/GamecenterEntriesPageScheduled';
import { useContestContext } from '../../../../common/context/ContestContext/ContestContext';
import { EntryNameEditModalContextProvider } from '../../../../common/context/EntryNameEditModalContext/EntryNameEditModalContext';
import ConfirmationModalContextProvider from '../../../../common/context/GamecenterConfirmationModalContext/ConfirmationModalContextProvider';
import getIsContestSingleSlate from '../../../../common/utils/getIsContestSingleSlate';
import EntryScheduledMultiSlate from '../../../../player/EntryScheduledMultiSlate/EntryScheduledMultiSlate';
import EntryScheduledSingleTier from '../../../components/EntryScheduledSingleSlate/EntryScheduledSingleSlate';
import usePlayerEntriesScheduled from '../../../hooks/usePlayerEntriesScheduled';
import GamecenterModalsContextProvider from '../../../../common/context/GamecenterModalsContext/GamecenterModalsContextProvider';

function PlayerTierEntriesPageScheduled() {
  const { isLoading, error, entries, hasNextPage, isFetchingNextPage, fetchNextPage } =
    usePlayerEntriesScheduled();
  const { contest } = useContestContext();
  const isSingleSlate = getIsContestSingleSlate(contest);

  return (
    <GamecenterModalsContextProvider>
      <ConfirmationModalContextProvider>
        <EntryNameEditModalContextProvider>
          <GamecenterEditedContestModal />
          <GamecenterEntriesPageScheduled
            isLoading={isLoading}
            error={error}
            entries={entries}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            fetchNextPage={fetchNextPage}
            EntryComponent={isSingleSlate ? EntryScheduledSingleTier : EntryScheduledMultiSlate}
          />
        </EntryNameEditModalContextProvider>
      </ConfirmationModalContextProvider>
    </GamecenterModalsContextProvider>
  );
}

export default PlayerTierEntriesPageScheduled;
